import { get, isEmpty, isNil, noop } from "lodash";
import { useMemo } from "react";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { DOCUMENT_STEPS } from "utils/constants";

const keepTypes = (attachments, types) =>
  isEmpty(types)
    ? attachments
    : attachments.filter(({ type }) => types.includes(type));

const useStaticAttachments = ({
  projectId,
  insurancePlanIds = [],
  upsellPlanIds,
  step = DOCUMENT_STEPS.DEVIS,
  types,
  onCompleted = noop,
}) => {
  const skip = isNil(projectId) || isEmpty(insurancePlanIds);
  const { data, loading, refetch } = useQuery(
    graphql.queries.STATIC_ATTACHMENTS,
    {
      variables: {
        where: { id: projectId },
        insurancePlans: insurancePlanIds.map((id) => ({ id })),
        upsells: upsellPlanIds && upsellPlanIds.map((id) => ({ id })),
        step,
      },
      skip,
      fetchPolicy: "network-only",
      onCompleted: (result) =>
        onCompleted(keepTypes(get(result, "staticAttachments") || [], types)),
    },
  );

  const attachments = useMemo(
    () => keepTypes(get(data, "staticAttachments") || [], types),
    [data, types],
  );

  return { attachments, loading: !skip && loading, refetch };
};

export default useStaticAttachments;
